const chunkArray = (arr, n) => {
  var chunkLength = Math.max(arr.length / n, 1);
  var chunks = [];

  for (var i = 0; i < n; i++) {
    if (chunkLength * (i + 1) <= arr.length)
      chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1)));
  }
  return chunks;
};

const findByMatchingProperties = (set, properties) => {
  return set.filter(function (entry) {
    return Object.keys(properties).every(function (key) {
      return entry[key] === properties[key];
    });
  });
}

export { chunkArray, findByMatchingProperties };
